/* unplugin-vue-components disabled */import script from "./translationTxt.vue?vue&type=script&lang=ts&setup=true"
export * from "./translationTxt.vue?vue&type=script&lang=ts&setup=true"

import "./translationTxt.vue?vue&type=style&index=0&id=55b1e2a2&lang=stylus"

const __exports__ = script;

export default __exports__